export default function({ dispatch, commit }) {
    // POST /auth/login
    return dispatch('post', {
        url: '/provider/auth/logout'
    }, {
        root: true
    })
    .then((response) => {
        commit('invalidatedToken')
        commit('provider/reset', null, {root: true })
        console.log('response', response)
    })
    .catch((error) => {
        console.log('error', error)
    })
}
